const NCM_DASHBOARD_MENU = {
  title: "Dashboard",
  route: "networkConfigurationDashboard",
  icon: "GridIcon",
}

const NCM_NODE_MANAGEMENT_MENU = {
  title: "Node Management",
  route: "networkConfigurationNodeManagement",
  icon: "ServerIcon",
}

const NCM_CONFIGURATION_HISTORY_MENU = {
  title: "Config History",
  route: "networkConfigurationConfigurationHistory",
  icon: "LayersIcon",
}

const NCM_CONFIGURATION_TEMPLATE_MENU = {
  title: "Config Template",
  route: "networkConfigurationConfigurationTemplate",
  icon: "FileTextIcon",
}

const NCM_CONFIGURATION_COMPARISON_MENU = {
  title: "Config Comparison",
  route: "networkConfigurationConfigurationComparison",
  icon: "CodeIcon",
}

const NCM_DISCOVERY_MENU = {
  title: "Discovery Node",
  route: "networkConfigurationDiscovery",
  icon: "ZoomInIcon",
}

const NCM_CREDENTIAL_MENU = {
  title: "Credential",
  route: "networkConfigurationCredential",
  icon: "KeyIcon",
}

const NCM_BACKUP_SETTINGS_MENU = {
  title: "Backup Settings",
  route: "networkConfigurationBackupSettings",
  icon: "SettingsIcon",
}

export {
  NCM_DASHBOARD_MENU,
  NCM_NODE_MANAGEMENT_MENU,
  NCM_CONFIGURATION_HISTORY_MENU,
  NCM_CONFIGURATION_TEMPLATE_MENU,
  NCM_CONFIGURATION_COMPARISON_MENU,
  NCM_DISCOVERY_MENU,
  NCM_CREDENTIAL_MENU,
  NCM_BACKUP_SETTINGS_MENU,
}
